import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export const getModules = async () => {
    try {
        const response = await Axios.get(`/user-permissions/modules`);
        return response.data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.response) {
            return error?.response?.data;
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetModules = () => {
    const modules = useQuery({ queryKey: ["get-all-modules"], queryFn: getModules });

    return modules;
};
